import React from 'react';
import { getdate, formatdate, updatedata } from "../../util/global";

const PatientView = ({ mode, setmode, formdata, appointmentdata, prescriptiondata }) => {
  if (mode !== "viewpatient") return null;

  const sendprescriptionreminder = async () => {
    if (!prescriptiondata || prescriptiondata.length == 0) {
      alert("No prescription found for this patient");
      return ;
    }
    let message = "*Prescription Reminder*\n\nThe prescribed duration for the following medicines will end shortly. " + 
    "Please contact Dr. Devika for followup.\n\n ";
    let medicinedata = prescriptiondata?.length > 0 ? prescriptiondata[0].medicinedata : [];
    for (let i=0; i < medicinedata.length;i++) {
      if (medicinedata[i].enddatestr?.length < 2) continue; 
      message += (i+1) + ". " + medicinedata[i].medicine + " | *Expiry: " + medicinedata[i].enddatestr + "*\n\n";
    }
    message += "\n\nView your full prescription: https://drnayak.org/forward.html?url=" + 
    encodeURIComponent("http://44.254.125.221/prescriptionview?" + 
      "prescriptionid=" + prescriptiondata[0]._id +  
      "&appname=" + window.APPSETTING.appname + "&adminuserid=" + window.APPSETTING.adminuserid);

    const payload = { data: { 
          status:"new",
          senderphonenumber:"919623078401",
          receiverphonenumber:[{phonenumber: "919545940430"},{phonenumber: "919764786256"},{phonenumber: "919623078401"}],
          message:message,
          datatype: "sendmessagedata" } };   
        console.log(payload);
        await updatedata(payload);
        alert("Prescription reminder sent to patient.");
  };

  const sendappointmentreminder = async () => {

      let message = "*Appointment Reminder*\n\nDr. Devika has recommended next apppointment for May 23 2026. " + 
      "Please book your appointment here - " + 
      " https://drnayak.org/forward.html?url=" + 
      encodeURIComponent("http://44.254.125.221/login?" +   
      "&appname=" + window.APPSETTING.appname + "&adminuserid=" + window.APPSETTING.adminuserid);
      
      const payload = { data: { 
            status:"new",
            senderphonenumber:"919623078401",
            receiverphonenumber:[{phonenumber: "919545940430"},{phonenumber: "919764786256"},{phonenumber: "919623078401"}],
            message:message,
            datatype: "sendmessagedata" } };   
          console.log(payload);
          await updatedata(payload);
          alert("Appointment reminder sent to patient.");
    };
    

  return (
    <div className="modal-overlay">
      <div className="modal-content" style={{ width: '800px', maxHeight: '90vh', overflowY: 'auto' }}>
        <button className="close-btn" onClick={() => setmode("")}>&times;</button>

        <div id="printarea" style={{ padding: '20px' }}>
          {/* Header Section: Photo & Basic Info */}
          <table style={{ border: 'none', marginBottom: '30px' }}>
            <tbody>
              <tr>
                <td style={{ width: '120px', border: 'none' }}>
                  <div style={{ width: '100px', height: '100px', backgroundColor: '#eee', borderRadius: '4px', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#999' }}>
                    Photo
                  </div>
                </td>
                <td style={{ border: 'none', verticalAlign: 'top' }}>
                  <h2 style={{ margin: '0 0 10px 0' }}>{formdata.name}</h2>
                  <p style={{ margin: '0' }}><strong>Phone:</strong> {formdata.phonenumber}</p>
                  <p style={{ margin: '0' }}><strong>Patient ID:</strong> {formdata._id}</p>
                </td>
              </tr>
            </tbody>
          </table>

          {/* Appointments Section */}
          <h3>Appointment History</h3>
          <table className="grid">
            <thead>
              <tr><th>Date</th><th>Status</th><th>Comment / Note</th></tr>
            </thead>
            <tbody>
              {appointmentdata.map((a, i) => (
                <tr key={i}>
                  <td>{a.datestr || a.datetime}</td>
                  <td><span className={`status-badge ${a.status?.toLowerCase()}`}>{a.status}</span></td>
                  <td>{a.comment}</td>
                </tr>
              ))}
              {appointmentdata.length === 0 && <tr><td colSpan="3">No appointments found.</td></tr>}
            </tbody>
          </table>

          {/* Prescription Section (Following PrescriptionAdminTable format) */}
          <h3>Prescription History</h3>
          <table className="grid">
            <thead>
              <tr><th style={{width:'100px'}}>date</th><th>medicine</th><th>dosage</th><th>instructions</th><th>status</th><th>end date</th></tr>
            </thead>
            <tbody>
              {prescriptiondata.map((p, i) => (
                  <>
                  {p.medicinedata?.map((med, midx) => {
                    const daysmatch = med.instructions?.match(/^[0-9]+/);
                    const days = daysmatch ? parseInt(daysmatch[0]) : 0;
                    let status = "-";
                    let enddatestr = "-";
                    if (days > 0 && p.datetime) {
                      const startdate = getdate(p.datetime).date;
                      const enddate = new Date(startdate.getTime() + (days * 24 * 60 * 60 * 1000));
                      enddatestr = formatdate(enddate);
                      status = enddate.getTime() < Date.now() ? "completed" : "ongoing";
                    }
                    med.enddatestr = enddatestr;
                    return (
                        <tr>
                          {midx === 0 && (<td style={{whiteSpace:'nowrap'}} rowSpan={p.medicinedata.length}>{p.datetime}</td>)}
                          <td>{med.medicine}</td>
                          <td>{med.dosage}</td>
                          <td>{med.instructions}</td>
                          <td>{status}</td>
                          <td style={{ whiteSpace: 'nowrap' }}>{enddatestr}</td>
                        </tr>
                    );
                  })}
                  
                </>
              ))}
              {prescriptiondata.length === 0 && <tr><td colSpan="2">No prescriptions found.</td></tr>}
            </tbody>
          </table>
        </div>

        <div style={{ display: 'flex', gap: '10px', padding: '0 20px 20px', justifyContent: 'flex-end' }}>
          <a href="#"  onClick={() => {sendprescriptionreminder();}}>Send Prescription Reminder</a>
          <a href="#"  onClick={() => {sendappointmentreminder()}}>Next Appointment Reminder</a>
        </div>
      </div>
    </div>
  );
};

export default PatientView;